"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const eventConstants_1 = require("../../../constants/eventConstants");
const styles_1 = __importDefault(require("../../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../../hooks/useWebDesktopDesign"));
const button_1 = __importDefault(require("../../button/button"));
const notesBox_1 = __importDefault(require("../notesBox/notesBox"));
const actionsSlice_1 = require("../../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const sendSMS_1 = __importDefault(require("../../communicationBox/sendSMS/sendSMS"));
const ticketForm_1 = __importDefault(require("../../ticketComponent/ticketForm"));
const modal_1 = __importDefault(require("../../modal/modal"));
const UserActions = ({ user, scheduleId }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const dispatch = useAppDispatch_1.default();
    const doNotCall = user.do_not_call;
    const selectedContact = {
        available_sms: [],
        first_name: user.first_name,
        last_name: user.last_name,
        phone_number: user.phone_number,
    };
    const [showAddNotes, setShowAddNotes] = react_1.useState(false);
    const [showSMSForm, setShowSMSForm] = react_1.useState(false);
    const [showTicketingForm, setShowTicketingForm] = react_1.useState(false);
    const [doNotNeedLoan, setDoNotNeedLoan] = react_1.useState(doNotCall);
    const flagAsDoNotCallHandler = () => {
        const payload = { scheduleId, selectedContact };
        dispatch(actionsSlice_1.flagAsDoNotCall(payload));
        setDoNotNeedLoan(!doNotNeedLoan);
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
        react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Actions", left: ({ size }) => react_1.default.createElement(react_native_paper_1.Avatar.Icon, { size: size, icon: "gesture-tap-button" }), titleStyle: styles_1.default.textColorBlack }),
        react_1.default.createElement(react_native_1.View, { style: [
                isDesktop ? styles_1.default.flexDirectionRow : styles_1.default.flexDirectionColumn,
                styles_1.default.flexWrap,
            ] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                react_1.default.createElement(button_1.default, { text: showTicketingForm ? 'Close Ticket' : 'Create Ticket', icon: free_solid_svg_icons_1.faFolderOpen, onPress: () => setShowTicketingForm(!showTicketingForm), eventName: eventConstants_1.TOGGLE_CREATE_USER_TICKET, fill: showTicketingForm })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                react_1.default.createElement(button_1.default, { text: showSMSForm ? 'Close SMS' : 'Send SMS', icon: free_solid_svg_icons_1.faSms, onPress: () => setShowSMSForm(!showSMSForm), eventName: eventConstants_1.TOGGLE_SEND_USER_SMS, fill: showSMSForm })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                react_1.default.createElement(button_1.default, { icon: free_solid_svg_icons_1.faPen, onPress: () => setShowAddNotes(!showAddNotes), eventName: eventConstants_1.TOGGLE_NOTES_INPUT, text: showAddNotes ? 'Close note' : 'Drop a note', fill: showAddNotes })),
            typeof doNotCall === 'boolean' && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen, styles_1.default.button] },
                react_1.default.createElement(button_1.default, { onPress: flagAsDoNotCallHandler, eventName: eventConstants_1.TOGGLE_NOTES_INPUT, text: doNotNeedLoan ? 'Need loan' : 'Do not need loan' })))),
        showAddNotes && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen] },
            react_1.default.createElement(notesBox_1.default, { scheduleId: scheduleId, hideNotes: () => setShowAddNotes(false) }))),
        showSMSForm && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen] },
            react_1.default.createElement(sendSMS_1.default, { selectedContact: selectedContact, setBaseContent: null, scheduleId: scheduleId }))),
        react_1.default.createElement(modal_1.default, { title: "Create Ticket", visible: showTicketingForm, hideModal: () => setShowTicketingForm(false), containerStyle: styles_1.default.modelFormTop },
            react_1.default.createElement(ticketForm_1.default, { ticket: null, user: user }))));
};
exports.default = UserActions;
